import type { AlignTypes, SpacingTypes } from '@etg/wings';
import { Stack, breakpoints } from '@etg/wings';
import { css, cx } from '@eti/styles';
import type { ElementType, ReactNode } from 'react';

interface StyledStackProps {
  align?: AlignTypes;
  as?: ElementType;
  children: ReactNode;
  className?: string;
  spacing?: SpacingTypes;
}

export const formWrapperStyles = (isMultiStop: boolean) => css`
  justify-content: center;

  @media (min-width: ${breakpoints._768}) {
    flex-direction: ${isMultiStop ? 'column' : 'row'};
  }
`;

const stackStyles = css`
  flex: 3;
`;

export const StyledStack = ({ as, className, children, ...rest }: StyledStackProps) => (
  <Stack as={as} className={cx(stackStyles, className)} {...rest}>
    {children}
  </Stack>
);

export const extendedSearchFormStyles = css`
  padding-block-start: 24px;
`;

export const linkButtonStyles = css`
  display: flex;
`;

export const iconStyles = (isExpanded: boolean) => css`
  margin-inline-start: 8px;
  transform: rotateX(${isExpanded ? '180deg' : '0deg'});
  transition: transform 0.15s ease-in-out;
`;

export const motionVariantsForDatesAndPassengers = {
  visible: {
    display: 'block',
    opacity: 1,
    top: 0,
    height: 'auto',
    transition: {
      type: 'tween',
      duration: 0.2,
    },
  },
  hidden: {
    opacity: 0,
    top: 700,
    height: 0,
    transition: {
      type: 'tween',
      duration: 0.3,
    },
  },
};

export const datesAndPassengersTransition = {
  animate: { top: 0, opacity: 1, height: 'auto' },
  initial: { top: 700, opacity: 0, height: 0 },
  exit: { top: 700, opacity: 0, height: 0 },
  transition: {
    type: 'tween',
    duration: 0.2,
  },
};

export const motionVariantsExtendedOptions = {
  show: {
    height: 'auto',
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.3,
      opacity: { delay: 0.3 },
    },
    transitionEnd: { overflow: 'visible' },
  },
  hide: {
    height: 0,
    opacity: 0,
    marginBottom: 0,
    transition: {
      type: 'tween',
      duration: 0.3,
      height: { delay: 0.3 },
      marginBottom: { delay: 0.3 },
    },
    transitionEnd: { overflow: 'hidden' },
  },
};
